// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dIUK","colMin":"styles_colMin__2Vsmf"};